module.exports = __webpack_public_path__ + "static/media/Q_2_6.c4ba8110.jpg";